import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import type {Location} from 'react-router';
// Custom hook to handle location changes including history.pushState
function useCustomLocation(): Location {
    const location = useLocation(); // Get initial location from react-router-dom
    const [currentLocation, setCurrentLocation] = useState<Location>(location);

    // Update currentLocation when React Router's location changes (e.g., browser back/forward)
    useEffect(() => {
        setCurrentLocation(location);
    }, [location]);

    // Sync with raw history.pushState navigations that dispatch 'location-changed',
    // plus browser back/forward via 'popstate'. React Router doesn't track these.
    useEffect(() => {
        const syncFromWindow = () => {
            setCurrentLocation((prev) => ({
                ...prev,
                pathname: window.location.pathname,
                search: window.location.search,
                hash: window.location.hash,
            }));
        };

        window.addEventListener('location-changed', syncFromWindow);
        window.addEventListener('popstate', syncFromWindow);

        return () => {
            window.removeEventListener('location-changed', syncFromWindow);
            window.removeEventListener('popstate', syncFromWindow);
        };
    }, []);

    return currentLocation;
}

export default useCustomLocation;
